module.exports = __webpack_public_path__ + "img/DE01624.92717920.png";